import { app } from '@/main'
import { setStorage, getStorage } from '@GUTIL/other'
import { ROLEID } from '@GUTIL/hardCode'

const cachePermissions = getStorage('permission')
const cacheMeInfo = getStorage('me_info')

const state = {
  // key: menu id,  value: { canRead: true/false, canWrite: true/false, ... }
  permissions: cachePermissions ? cachePermissions : {},
  meInfo: cacheMeInfo ? cacheMeInfo : {}
}

const actions = {
  async [_GM.SET_LOGIN_ACCOUNT_INFO]({ dispatch, commit, rootState }) {
    commit(_GM.SET_SIDE_MENU_LOADING, true)
    commit(_GM.RESET_SIDE_MENU)

    // call getMe to get login user's information
    let graphProvider =
      rootState.Global.folderName == 'operator'
        ? app.$operatorGraphqlProvider
        : app.$departmentGraphqlProvider
    try {
      // id 為 0 時, 代表取登入者的資料
      let { account } = await graphProvider.getAccount({ id: 0 })
      let { getMenu } = await graphProvider.getMenu()

      // 增加 role 功能開關，管理所有角色權限
      typeof account === 'object' && (account.feature = { isCashier: false })

      // 提現員權限開關設定，
      if (account && account.roles) {
        let isCashier = false
        let isOP = false
        account.roles.forEach(row => {
          row.id === ROLEID.CASHIER && (isCashier = true)
          row.id === ROLEID.OPERATOR && (isOP = true)
        })
        isOP || (isCashier && (account.feature.isCashier = true))
      }

      setStorage('me_info', account)
      commit(_GM.SET_LOGIN_ACCOUNT_INFO, account)
      dispatch(_GM.SET_LOGIN_ACCOUNT_PERMISSION, getMenu ? getMenu : [])
    } catch (e) {
      console.log(e)
    }
  },
  async [_GM.SET_LOGIN_ACCOUNT_PERMISSION](
    { commit, state, rootState },
    menus
  ) {
    // 後端 menu 會給一、二層, 一層parentID為0
    const allowedMenuIds = [],
      allowedPermission = {}

    menus.forEach(menu => {
      if (menu.code) {
        // 在此將code轉成目前專案使用的menuId  e.g. XO4001 => XO4.1
        const menuId =
          menu.parentID > 0 // 是否為第二層
            ? `${menu.code.slice(0, -3)}.${parseInt(menu.code.slice(-3))}`
            : menu.code

        // if action has any permission
        if (menu.action && menu.action.length > 0) {
          allowedMenuIds.push(menuId)
        }

        allowedPermission[menuId] = {
          canRead: menu.action ? menu.action.indexOf(1) >= 0 : false,
          canWrite: menu.action ? menu.action.indexOf(2) >= 0 : false,
          canDelete: menu.action ? menu.action.indexOf(3) >= 0 : false
        }
      }
    })

    setStorage('permission', allowedPermission)
    commit(_GM.SET_LOGIN_ACCOUNT_PERMISSION, allowedPermission)
    commit(_GM.SET_SIDE_MENU, {
      folderName: rootState.Global.folderName,
      allowedMenuIds
    })
    commit(_GM.SET_SIDE_MENU_LOADING, false)
  }
}

const mutations = {
  [_GM.SET_LOGIN_ACCOUNT_INFO](state, meInfo) {
    state.meInfo = meInfo
  },
  [_GM.SET_LOGIN_ACCOUNT_PERMISSION](state, permissions) {
    state.permissions = permissions
  }
}

const getters = {
  permissions: state => state.permissions,
  meInfo: state => state.meInfo
}

export default {
  state,
  actions,
  mutations,
  getters
}
